import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry
} from 'ngx-file-drop'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import * as XLSX from 'xlsx'
@Component({
  selector: 'app-import-shipping-fase-one',
  templateUrl: './import-shipping-fase-one.component.html',
  styleUrls: ['./import-shipping-fase-one.component.css']
})
export class ImportShippingFaseOneComponent implements OnInit {
  datositemsInsert=[];
  dataexcel:any;
  arrayMensajesMasivoExcel = []
  Customer = []
  itemsImport=[];
  PlaceOrderStatusDescripcion = []
  valorCustomerMasivo = ''
  SelectStatusDescripcion = ''
  viewRegistrosMasivos = false
  constructor (
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<ImportShippingFaseOneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this. itemsImport=[];
    this.arrayMensajesMasivoExcel = []
    this.Customer = []
    this.PlaceOrderStatusDescripcion = []
    this.datositemsInsert=[];
    this.OnSelectStatusDescripcion()
    this.OnSelectCostumer()
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {}

  public files2: NgxFileDropEntry[] = []

  public dropped2 (files: NgxFileDropEntry[]) {
    this.files2 = files
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file)
          let workBook = null
          let jsonData = null
          var reader = new FileReader()

          reader.onload = event => {
            const data = reader.result
            workBook = XLSX.read(data, { type: 'binary' })
            jsonData = workBook.SheetNames.reduce((initial, name) => {
              const sheet = workBook.Sheets[name]
              initial[name] = XLSX.utils.sheet_to_json(sheet)
              return initial
            }, {})

           this.dataexcel=jsonData;

            this.viewRegistrosMasivos = true
          }

          reader.readAsBinaryString(file)
        })
      } else {
      }
    }
    setTimeout(() => {
      this.OnProcesarExcel(this.dataexcel)
    }, 1000);
  }

  public fileOver2 (event) {
    console.log(event)
  }

  public fileLeave2 (event) {
    console.log(event)
  }

OnProcesarExcel(jsonData:any){
try {
  this.itemsImport=jsonData.items
} catch (error) {
  
}
console.log(jsonData)
  for (let index = 0; index < jsonData.shipping.length; index++) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['tblCustomerID'] = Number(this.valorCustomerMasivo)
    Request['poNumber'] =
      String(jsonData.shipping[index].poNumber) || ''
    Request['refNumber'] =
      String(jsonData.shipping[index].refNumber) || ''
    Request['shipDate'] = jsonData.shipping[index].shipDate || null
    Request['cancelShipDate'] =
      jsonData.shipping[index].cancelShipDate || null
    Request['notes'] = String(jsonData.shipping[index].notes) || ''
    Request['status'] = '0'
    Request['createdByUserID'] = Number(json.whId)
    Request['comments'] =
      String(jsonData.shipping[index].comments) || ''
    Request['confirmation'] =
      String(jsonData.shipping[index].confirmation) || ''
    Request['tblCompanyStatusDescriptionID'] = Number(
      Number(this.SelectStatusDescripcion) || 0
    )
    Request['Routing'] = Number(jsonData.shipping[index].Routing||0)
    Request['Billed'] = Number(jsonData.shipping[index].Billed||0)
    Request['AllChargesAdded'] = Number(
      jsonData.shipping[index].AllChargesAdded||0
    )
    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrder`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(response)

        var resp = String(response.responses)
        var iter = index
        if (resp.includes('success')) {
          var spl = resp.replace('success-', '')
          ///  localStorage.setItem('OrderData', JSON.stringify(Request))
          this.OnDialogPlaceOrderTwo(
            spl,
            Number(this.valorCustomerMasivo),
            jsonData.shipping[index],
            jsonData.shipto[index],
            jsonData.carrier[index],
            jsonData.billto[index]
          )
          var ad = {
            celda: iter + 1,
            itemname: String(jsonData.shipping[index].poNumber),
            mensajes: spl
          }

          this.arrayMensajesMasivoExcel.push(ad)
         try {
          var grouped = this.groupBy(this.itemsImport, pet => pet.order)
          this.OnImportItems(spl,grouped.get(index))
         } catch (error) {
          
         }
        } else {
        }
      })
  }


}



  OnSelectStatusDescripcion () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderStatusDescripcion`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceOrderStatusDescripcion = response
      })
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['CompanyId'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['Active'] = String('1')

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        this.Customer = response
      })
  }

  OnDialogPlaceOrderTwo (
    ordernumber: any,
    idc:any,
    orderdata: any,
    shipto: any,
    carrier: any,
    billto: any
  ) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var order = {}
    var Shipto = {}
    var Request = {}
    var tblContact = {}
    var tblCarrier = {}

    order['tblCustomerID'] = Number(idc)
    order['poNumber'] = String(orderdata.poNumber || '')
    order['refNumber'] = String(orderdata.refNumber || '')
    order['shipDate'] = orderdata.shipDate || null
    order['cancelShipDate'] = orderdata.cancelShipDate || null
    order['notes'] = String(orderdata.notes || '')
    order['status'] = '1'
    order['createdByUserID'] = Number(orderdata.createdByUserID)
    order['comments'] = String(orderdata.comments || '')
    order['confirmation'] = String(orderdata.confirmation || '')
    order['tblCompanyStatusDescriptionID'] = Number(
      Number(this.SelectStatusDescripcion) || 0
    )

    Shipto['tblOrderID'] = Number(ordernumber)
    Shipto['companyName'] = String(shipto.companyName || '')
    Shipto['address'] = String(shipto.address || '')
    Shipto['address1'] = String(shipto.address1 || '')
    Shipto['city'] = String(shipto.city || '')
    Shipto['state'] = String(shipto.state || '')
    Shipto['zipCode'] = String(shipto.zipCode || '')
    Shipto['phone'] = String(shipto.phone || '')
    Shipto['fax'] = String(shipto.fax || '')
    Shipto['contactName'] = String(shipto.contactName || '')
    Shipto['contactEmail'] = String(shipto.contactEmail || '')
    Shipto['contactPhone'] = String(shipto.contactPhone || '')

    tblContact['tblCompanyID'] = Number(json.companyIdWh)
    tblContact['companyName'] = String(shipto.companyName || '')
    tblContact['address'] = String(shipto.address || '')
    tblContact['address1'] = String(shipto.address1 || '')
    tblContact['city'] = String(shipto.city || '')
    tblContact['state'] = String(shipto.state || '')
    tblContact['zipCode'] = String(shipto.zipCode || '')
    tblContact['phone'] = String(shipto.phone || '')
    tblContact['fax'] = String(shipto.fax || '')
    tblContact['contactName'] = String(shipto.contactName || '')
    tblContact['contactEmail'] = String(shipto.contactEmail || '')
    tblContact['contactPhone'] = String(shipto.contactPhone || '')

    tblCarrier['tblOrderID'] = Number(ordernumber)
    tblCarrier['carrier'] = String(carrier.carrier || '')
    tblCarrier['scac'] = String(carrier.scac || '')
    tblCarrier['serviceType'] = String(carrier.serviceType || '')
    tblCarrier['billing'] = String(carrier.billing || '')
    tblCarrier['accountNumber'] = String(carrier.accountNumber || '')
    tblCarrier['capacity'] = String(carrier.capacity || '')
    tblCarrier['cod'] = String(carrier.cod || '')
    tblCarrier['loadNumber'] = String(carrier.loadNumber || '')
    tblCarrier['bol'] = String(carrier.bol || '')
    tblCarrier['trackingNumber'] = String(carrier.trackingNumber || '')
    tblCarrier['trailerNumber'] = String(carrier.trailerNumber || '')
    tblCarrier['sealNumber'] = String(carrier.sealNumber || '')
    tblCarrier['pickupDate'] = String(carrier.pickupDate || '')
    tblCarrier['doorNumber'] = String(carrier.doorNumber || '')
    tblCarrier['warehouseInstructions'] = String(
      carrier.warehouseInstructions || ''
    )
    tblCarrier['carrierInstructions'] = String(
      carrier.carrierInstructions || ''
    )
    Request['tblContact'] = tblContact
    Request['tblCarrier'] = tblCarrier
    Request['Shipto'] = Shipto
    Request['tbId'] = String(ordernumber)
    Request['order'] = order

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderTwo`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.onSaveBiillto(ordernumber, billto)
      })

    // this.dialogRef.close();
  }

  onSaveBiillto (orderNumber: any, datos: any) {
    var Shipto = {}
    Shipto['tblOrderID'] = Number(orderNumber)
    Shipto['companyName'] = String(datos.companyName || '')
    Shipto['address'] = String(datos.address || '')
    Shipto['address1'] = String(datos.address1 || '')
    Shipto['city'] = String(datos.city || '')
    Shipto['state'] = String(datos.state || '')
    Shipto['zipCode'] = String(datos.zipCode || '')
    Shipto['phone'] = String(datos.phone || '')
    Shipto['fax'] = String(datos.fax || '')
    Shipto['contactName'] = String(datos.contactName || '')
    Shipto['contactEmail'] = String(datos.contactEmail || '')
    Shipto['contactPhone'] = String(datos.contactPhone || '')
    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/BillToShippingNewOrUpdata`,
        Shipto,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {})
  }

OnImportItems(order:any,items:any){

for (let index = 0; index < items.length; index++) {
  const element = items[index];
  this.http
      .get<any>(`${environment.apiUrl}/Administracion/searchproductforitemnumber?CustomerID=${this.valorCustomerMasivo}&item=${encodeURIComponent(String(element.itemNumber))}`, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        console.log(response,'searchitesms',element)
        var yy=[];
        yy=response;
       for (let index2 = 0; index2 < yy.length; index2++) {
        const element2 = yy[index2];
       if (index2==0) {
        if (Number(element.quantity)<Number(element2.available)) {
          this.onInsertItemsExcel(element,order,element2)
        } else {
          if(Number(element.quantity)==Number(element2.available)){
            this.onInsertItemsExcel(element,order,element2)
          }
        }
       }
       }
      })
}
}
onInsertItemsExcel(da:any,or:any,pro:any){
  console.log('onInsertItemsExcel')
  var Request = {}
  Request['tblOrderID'] = Number(or)
  Request['tblProductID'] = Number(pro.id)
  Request['quantity'] = Number(da.quantity|| 1)
  Request['status'] = '0'
  Request['miscNumber'] = String(da.miscNumber)
  Request['tblReceivingProductsItemsID'] = Number(
    pro.receivingID
  )
  Request['palletCount'] = Number(da.palletCount||1)
  Request['tblReceivingProductsLocationID'] = Number(
    pro.locationID
  )

  this.http
    .post<any>(
      `${environment.apiUrl}/Shipping/PlaceOrderNewOrderItems`,
      Request,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any) => {
     try {
      
      var j={
        order:Number(or),
        product:String(da.itemNumber),
        quantity:Number(da.quantity),
        result:String(response.responses)
        
                  }
        this.datositemsInsert.push(j)
     } catch (error) {
      
     }
    })
}

filterDataitemsImport(locationName: string) {
  return this.itemsImport.filter((object) => {
  if (object["order"]==locationName) {
    return object;
  }
  });
}
groupBy (list, keyGetter) {
  const map = new Map()
  list.forEach(item => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}
exportAsExcel() {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
    this.datositemsInsert
  ); //converts a DOM TABLE element to a worksheet
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'items');

  /* save to file */
  XLSX.writeFile(wb, 'importShipping.xlsx');
}
}
